import MetaLiftStudy from "./MetaLiftStudy";

export default MetaLiftStudy;
